import type { IconSvgObject } from './types';

const CornerDownRightIcon: IconSvgObject = [
  ["path", { d: "M15 10.002L20 15.002L15 20.002M19 15.002H7C5.34315 15.002 4 13.6588 4 12.002V4.00195", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default CornerDownRightIcon;
